import { TRESPONSE_TNA_BOARD_LISTING } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TTnaBoardState = {
  tnaBoardInfo: TRESPONSE_TNA_BOARD_LISTING | null;
  userPaginationOption: TUserPaginationOption;
};

export const TTnaBoardActionType = {
  GetTnaBoardList: 'GET_TNA_BOARD_LIST' as const,
  GetTnaBoardListSucess: 'GET_TNA_BOARD_LIST_SUCESS' as const,
  GetTnaBoardListFaliure: 'GET_TNA_BOARD_LIST_FALIURE' as const,
};
